import {IViewerState} from './type';
import {getClientStore} from '../common/store';
import {
  ISendViewImpParam,
  sendEvent,
  sendViewImp,
} from '../common/util/tracking';
import {ITrackEventParam} from '../common/util/tracking/tiara';

export function makeLoadList(initPage: number, totalPage: number) {
  const result = [initPage];
  for (let i = 1; i < totalPage; i++) {
    if (initPage + i < totalPage) {
      result.push(initPage + i);
    }
    if (initPage - i >= 0) {
      result.push(initPage - i);
    }
  }
  return result;
}

export async function requestImage(
  path: string
): Promise<ArrayBuffer | undefined> {
  return new Promise(resolve => {
    const req = new XMLHttpRequest();
    req.open('GET', path, true);
    req.responseType = 'arraybuffer';
    req.onload = function () {
      const arrayBuffer = req.response;
      resolve(arrayBuffer);
    };
    req.onerror = () => resolve(undefined);
    req.send(null);
  });
}

let promiseCache: Promise<boolean> | undefined;
export function getIsWebpSupported() {
  if (promiseCache !== undefined) {
    return promiseCache;
  }
  promiseCache = new Promise<boolean>(resolve => {
    const image = new Image();
    function testWebp(e: Event | string) {
      // 아래 로직은 Modernizr 참고함
      // https://github.com/Modernizr/Modernizr/blob/400db4043c22af98d46e1d2b9cbc5cb062791192/feature-detects/img/webp.js
      const result =
        typeof e === 'object' && e.type === 'load' ? image.width === 1 : false;
      resolve(result);
    }
    image.onerror = testWebp;
    image.onload = testWebp;
    image.src =
      'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  });
  return promiseCache;
}

export function getIsLayeredState(state: IViewerState) {
  return state === 'comment' || state === 'setting';
}

export function sendViewerEvent({
  actionName,
  action,
  customProps,
}: {
  actionName: string;
  action: ITrackEventParam['action'];
  customProps: {[key: string]: any};
}) {
  const episode = getClientStore()?.getState().viewer.episode;
  sendEvent({
    section: 'viewer',
    page: 'viewer',
    action,
    actionName,
    customProps: {
      ...customProps,
      page_content_id: episode?.contentId,
      page_episode_id: episode?.id,
    },
  });
}

export function sendViewerViewImp({
  customProps,
  viewImpContents,
}: Pick<ISendViewImpParam, 'customProps' | 'viewImpContents'>) {
  const episode = getClientStore()?.getState().viewer.episode;
  sendViewImp({
    section: 'viewer',
    page: 'viewer',
    customProps: {
      ...customProps,
      page_content_id: episode?.contentId,
      page_episode_id: episode?.id,
    },
    viewImpContents,
  });
}

export const getViewerLsMapKey = (contendId: number, episodeId: number) =>
  `${contendId}_${episodeId}`;

export function getIsTouchEvent(e: MouseEvent | TouchEvent): e is TouchEvent {
  return 'touches' in e;
}

export const THRESHOLD_TO_MOVE_EPISODE = 50;
